import DonateFormIhoDelivery from 'javascripts/components/DonateForm/Iho/Delivery';
import DonateFormIhoDesign from 'javascripts/components/DonateForm/Iho/Design';
import DonateFormIhoDetails from 'javascripts/components/DonateForm/Iho/Details';
import DonateFormIhoPreview from 'javascripts/components/DonateForm/Iho/Preview';
import DonateFormIhoSpringMonthSelection from 'javascripts/components/DonateForm/Iho/SpringMonthSelection';
import Modal from 'javascripts/components/Modal';
import React, {Fragment} from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {autorun, reaction} from 'mobx';
import {observer} from 'mobx-react';

@observer
class DonateFormIhoModal extends React.Component {
  propagateModalState = () => {
    store.iho.modalOpen = this.modal.state.show;
  }

  componentWillUnmount = () => {
    ['ModalOpened', 'ModalClosed'].map((eventName) => {
      document.removeEventListener(
        eventName,
        this.propagateModalState,
      );
    });
  }

  componentDidMount = () => {
    // propagate state between the modal state and the store state
    ['ModalOpened', 'ModalClosed'].map((eventName) => {
      document.addEventListener(
        eventName,
        this.propagateModalState,
      );
    });

    reaction(
      () => store.iho.modalOpen,
      (modalOpen) => {
        this.modal.toggle(modalOpen);
      },
      { delay: 1 }
    );

    autorun(() => {
      this.modal.setToggleDisabled(store.iho.chooseDesignMode);
    });

    autorun(() => {
      if(store.iho.honoreeInfoIsPresent) {
        window.analytics.track('Finished IHO modal');
      }
    });

    autorun(() => {
      if(store.iho.step ===
        store.iho.steps[store.iho.steps.indexOf('type') + 1]) {
        window.analytics.track(`Selected ${store.iho.honoreeDraft.type} IHO`);
      }
    });
  };

  handleNextClick = (event) => {
    event.preventDefault();
    event.target.blur();
    window.scrollTo(0, 0);

    if (store.iho.tab == 'month-selection' || store.iho.tab == 'preview') {
      this.finish();
    }

    store.iho.tab = 'form';
    const parsley = $(this.inputs).parsley();

    if(parsley != undefined) {
      parsley.isValid() ? this.finishOrHandleNextStep() : parsley.validate();
    }
  }

  finishOrHandleNextStep = () => {
    if(store.iho.isLastStep) {
      this.finish();
    } else {
      store.iho.handleNextStep();
    }
  };

  finish = () => {
    store.iho.modalOpen = false;
    store.iho.saveHonoree();
    store.donateForm.step = store.donateForm.country == 'uk' ? 'gift-aid' : 'payment';
  }

  handlePreviousClick = (event) => {
    event.preventDefault();
    store.iho.handlePreviousStep();
    window.scrollTo(0, 0);
  };

  handleTabClick = (tab) => {
    const parsley = $(this.inputs).parsley();

    if(parsley != undefined) {
      if(parsley.isValid()) {
        store.iho.tab = tab;
      } else {
        parsley.validate();
      }
    } else {
      store.iho.tab = tab;
    }
  };

  render() {
    const {
      honoreeFullName,
      recipientFullName,
      sendTo,
      type,
    } = store.iho.honoreeDraft;

    let modalInterior;

    if(store.iho.chooseDesignMode) {
      modalInterior = (
        <Fragment>
          <div
            className='iho-header'
          >
            <h2 className='h40 text-center'>
              Choose another design
            </h2>
          </div>
          <div
            className='iho-form'
          >
            <div
              className='iho-body'
            >
              <DonateFormIhoDesign
                onDesignClick={() => store.iho.chooseDesignMode = !store.iho.chooseDesignMode}
              />
            </div>
          </div>
          <div
            className='modal-footer text-left'
          >
            <button
              className='button--grey-40'
              onClick={() => store.iho.chooseDesignMode = !store.iho.chooseDesignMode}
            >
              <i className='cw-icon-angle-left icon-left' />
              Back to Edit
            </button>
          </div>
        </Fragment>
      );
    } else {
      modalInterior = (
        <div
          className={cx(`iho-form ${type}`, {edit: store.iho.honoreeInfoIsPresent})}
        >
          {!store.iho.honoreeInfoIsPresent &&
            <div
              className='iho-body'
              data-parsley-validate
              ref={el => this.inputs = el}
            >
              {store.iho.step === 'type' &&
                <Fragment>
                  <div
                    className='iho-header'
                  >
                    <h3 className='h80 text-center pb-1'>Type</h3>
                    <h2 className='h40 text-center'>
                      How would you like to share your gift of
                      clean&nbsp;water?
                    </h2>
                  </div>
                  <div
                    className='select-type'
                  >
                    <div
                      className={cx('type', {active: type === 'email'})}
                      onClick={() => store.iho.updateHonoreeDraft({target: {value: 'email', name: 'type'}})}
                    >
                      <div className='icon email' />
                      <h3 className='h60'>Email a card</h3>
                      <p className='my-2'>Send an e-card straight to
                        someone&#8217;s&nbsp;inbox</p>
                    </div>
                    <div
                      className={cx('type', {active: type === 'print'})}
                      onClick={() => store.iho.updateHonoreeDraft({target: {value: 'print', name: 'type'}})}
                    >
                      <div className='icon print' />
                      <h3 className='h60'>Print at home</h3>
                      <p className='my-2'>Print a card at home to send
                        by&nbsp;mail</p>
                    </div>
                  </div>
                </Fragment>
              }
              {store.iho.step === 'details' &&
                <Fragment>
                  <div
                    className='iho-header'
                  >
                    <h3 className='h80 text-center pb-1'>Dedication</h3>
                    <h2
                      className='h40 text-center'
                      dangerouslySetInnerHTML={{__html: t(`views.donate_form.iho.${type}.details.header`)}}
                    />
                  </div>
                  <DonateFormIhoDetails />
                </Fragment>
              }
              {store.iho.step === 'delivery' &&
                <Fragment>
                  <div
                    className='iho-header'
                  >
                    <h3 className='h80 text-center pb-1'>{t(`views.donate_form.iho.${type}.delivery.subheader`)}</h3>
                    <h2
                      className='h40 text-center'
                      dangerouslySetInnerHTML={{__html: t(`views.donate_form.iho.${type}.delivery.header`)}}
                    />
                  </div>
                  <DonateFormIhoDelivery />
                  {type === 'print' &&
                    <DonateFormIhoDesign />
                  }
                </Fragment>
              }
              {store.iho.step === 'design' &&
                <Fragment>
                  <div
                    className='iho-header'
                  >
                    <h3 className='h80 text-center pb-1'>Design</h3>
                    <h2
                      className='h40 text-center'
                    >
                      Customize the look and feel of
                      your&nbsp;e-card
                    </h2>
                  </div>
                  <DonateFormIhoDesign />
                </Fragment>
              }
              {store.iho.step === 'preview' &&
                <Fragment>
                  <div
                    className='iho-header'
                  >
                    <h3 className='h80 text-center pb-1'>Preview</h3>
                    <h2
                      className='h40 text-center'
                      dangerouslySetInnerHTML={{__html: t(`views.donate_form.iho.${type}.preview.header`, {name: (sendTo === 'honoree' ? honoreeFullName : recipientFullName)})}}
                    />
                  </div>
                  <DonateFormIhoPreview
                    host={this.props.host}
                  />
                </Fragment>
              }
            </div>
          }

          {store.iho.honoreeInfoIsPresent &&
            <Fragment>
              <div
                className='toggle-buttons'
              >
                {store.iho.isSpringIho &&
                  <a
                    className={cx({active: store.iho.tab == 'month-selection'})}
                    onClick={() => this.handleTabClick('month-selection')}
                  >
                    Amount
                  </a>
                }
                <a
                  className={cx({active: store.iho.tab == 'form'})}
                  onClick={() => {store.iho.tab = 'form';}}
                >
                  {store.iho.isSpringIho && window.isMobile ? 'Edit' : 'Edit details'}
                </a>
                <a
                  className={cx({active: store.iho.tab == 'preview'})}
                  onClick={() => this.handleTabClick('preview')}
                >
                  Preview
                </a>
              </div>
              {store.iho.tab == 'month-selection' &&
                <div
                  className='iho-body'
                >
                  <DonateFormIhoSpringMonthSelection />
                </div>
              }
              {store.iho.tab == 'preview' &&
                <div
                  className='iho-body'
                >
                  <DonateFormIhoPreview
                    host={this.props.host}
                  />
                </div>
              }
              {store.iho.tab == 'form' &&
                <div
                  className='iho-body'
                  data-parsley-validate
                  ref={el => this.inputs = el}
                >
                  <div className='input-wrapper half-sized text-left'>
                    <label>Card Type</label>
                    <select
                      name='type'
                      onChange={store.iho.updateHonoreeDraft}
                      value={type}
                    >
                      <option value="email">Email</option>
                      <option value="print">Printable</option>
                    </select>
                  </div>
                  <div className='design'>
                    <img
                      src={store.iho.design.printImageUrl}
                    />
                    <a
                      className='p40'
                      onClick={() => store.iho.chooseDesignMode = !store.iho.chooseDesignMode}
                    >
                      Choose another design
                      <i className='cw-icon-chevron-right' />
                    </a>
                  </div>
                  <DonateFormIhoDetails />
                  <DonateFormIhoDelivery />
                </div>
              }
            </Fragment>
          }
          <div className='modal-footer'>
            <button
              onClick={this.handleNextClick}
            >
              {store.iho.honoreeInfoIsPresent ? (
                ['Save']
              ) : (
                <Fragment>
                  Next
                  <i className='cw-icon-angle-right icon-right' />
                </Fragment>
              )}
            </button>
            {!store.iho.isFirstStep && !store.iho.honoreeInfoIsPresent &&
              <button
                onClick={this.handlePreviousClick}
              >
                <i className='cw-icon-angle-left icon-left' />
                Back
              </button>
            }
          </div>
        </div>
      );
    }

    return(
      <Modal
        containerClassName={cx('iho', {edit: store.iho.honoreeInfoIsPresent, 'choose-design': store.iho.chooseDesignMode})}
        modalId='iho'
        ref={el => this.modal = el}
      >
        {modalInterior}
      </Modal>
    );
  }
}

export default DonateFormIhoModal;
